/* eslint-disable */
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  Input,
  Select,
  VStack,
  Heading,
  Text,
  useColorModeValue
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { DEPARTMENTS } from "../../constants/departments";
import AdminNavTop from "../AdminNavTop";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { patchUser } from "../../Redux/AdminReducer/action";
import { useModalToast } from "../../context/GlobalModalToast";

const EditUser = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const store = useSelector((store) => store.AdminReducer.users);
  const existedUser = store.filter((el) => el._id === id);
  const navigate = useNavigate();
  const { toast } = useModalToast();

  const userData = existedUser[0] || {};
  const currentUserRole = JSON.parse(localStorage.getItem('user'))?.role || '';

  const [detail, setDetail] = useState({
    name: userData.fullName || userData.name || "",
    email: userData.email || "",
    password: "",
    role: userData.role || "employee",
    department: userData.department || "Global",
    nationality: userData.nationality || "Global",
    gender: userData.gender || "",
  });

  const [nationalities, setNationalities] = useState([]);

  useEffect(() => {
    const fetchNationalities = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/nationalities`);
        setNationalities(res.data);
      } catch (err) {
        console.error("Failed to load nationalities", err);
      }
    };
    fetchNationalities();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDetail((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    dispatch(patchUser(id, detail));
    toast({ title: "User Updated Successfully", status: "success", duration: 2000 });
    navigate("/admin/users");
  };

  const bgMain = useColorModeValue("var(--background)", "gray.900");
  const cardBg = useColorModeValue("white", "rgba(15, 23, 42, 0.7)");
  const textMain = useColorModeValue("gray.800", "gray.100");
  const textSub = useColorModeValue("gray.700", "gray.300");
  const cardBorder = useColorModeValue("gray.100", "rgba(255, 255, 255, 0.08)");
  const inputBg = useColorModeValue("white", "rgba(15, 23, 42, 0.5)");

  return (
    <Grid className="Nav" h={"99vh"} w="94%" gap={10} bg={bgMain} color={textMain}>
      <Box mt="90px">
        <AdminNavTop />

        <Box
          className="glass-card"
          borderRadius="2xl"
          p={8}
          bg={cardBg}
          boxShadow="var(--shadow-premium)"
          maxW="600px"
          mx="auto"
          border="1px solid"
          borderColor={cardBorder}
        >
          <Heading size="md" mb={6} color={textMain} fontWeight="800">
            ✏️ Edit Employee Profile
          </Heading>

          <VStack spacing={5} align="stretch">
            <FormControl>
              <FormLabel fontWeight="600" color={textSub} fontSize="sm">Employee Full Name</FormLabel>
              <Input
                type="text"
                placeholder="Full Name"
                name="name"
                value={detail.name}
                onChange={handleChange}
                borderRadius="xl"
              />
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="600" color={textSub} fontSize="sm">Corporate Email</FormLabel>
              <Input
                type="email"
                placeholder="employee@company.com"
                name="email"
                value={detail.email}
                onChange={handleChange}
                borderRadius="xl"
              />
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="600" color={textSub} fontSize="sm">New Password (leave blank to keep current)</FormLabel>
              <Input
                type="password"
                placeholder="Set new password"
                name="password"
                value={detail.password}
                onChange={handleChange}
                borderRadius="xl"
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel fontWeight="600" color={textSub} fontSize="sm">Corporate Role</FormLabel>
              <Select
                name="role"
                value={detail.role}
                onChange={handleChange}
                borderRadius="xl"
                bg={inputBg}
              >
                <option value="employee">Employee</option>
                <option value="instructor">Instructor</option>
                <option value="admin">Admin</option>
                {currentUserRole === 'super_admin' && (
                  <option value="super_admin">SuperAdmin</option>
                )}
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="600" color={textSub} fontSize="sm">Branch/Company</FormLabel>
              <Input
                type="text"
                name="companyName"
                value={detail.companyName || "Global"}
                isReadOnly
                bg="gray.100"
                borderRadius="xl"
              />
              <Text fontSize="xs" color="gray.500" mt={1}>Company assignments are synced from HCM and cannot be edited here.</Text>
            </FormControl>

            <FormControl isRequired>
              <FormLabel fontWeight="600" color={textSub} fontSize="sm">Department / Sector</FormLabel>
              <Select
                name="department"
                value={detail.department}
                onChange={handleChange}
                borderRadius="xl"
                bg={inputBg}
              >
                {DEPARTMENTS.map((dept) => (
                  <option key={dept} value={dept}>{dept}</option>
                ))}
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="600" color={textSub} fontSize="sm">Nationality</FormLabel>
              <Select
                name="nationality"
                value={detail.nationality}
                onChange={handleChange}
                borderRadius="xl"
                bg={inputBg}
              >
                <option value="Global">Global</option>
                {nationalities.map((nat) => (
                  <option key={nat._id} value={nat.name}>{nat.name}</option>
                ))}
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel fontWeight="600" color={textSub} fontSize="sm">Gender</FormLabel>
              <Select
                name="gender"
                value={detail.gender}
                onChange={handleChange}
                borderRadius="xl"
                bg={inputBg}
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </Select>
            </FormControl>

            <Button
              mt={4}
              className="premium-gradient hover-lift"
              color="white"
              size="lg"
              w="full"
              borderRadius="xl"
              onClick={handleSubmit}
            >
              Save Changes
            </Button>
          </VStack>
        </Box>
      </Box>
    </Grid>
  );
};

export default EditUser;
